module.exports = __webpack_public_path__ + "static/media/image5.83315612.png";